export default __webpack_public_path__ + "static/media/mediterraneandrink@2x.bf1ed981.jpg";